import { LayoutComponent } from "../../../components";
import { Outlet } from "react-router-dom";

export function WorkshopsLayoutView() {
  return (
    <LayoutComponent selectedMenuItem={"workshops"}>
      <Outlet />
    </LayoutComponent>
  );
}
